import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material/';


export default function Dialog_yes_no({ question, onAnswer,open,onClose }) {
  
  
  const handleAnswer = (answer) => {
    onAnswer(answer);    
    onClose();
  };

  
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle></DialogTitle>
      <DialogContent>
        <DialogContentText>
        {question}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleAnswer(true)} variant="containedFifth">
          Oui
        </Button>
        <Button onClick={() => handleAnswer(false)} variant="containedFifth" autoFocus>
          Non
        </Button>
      </DialogActions>
    </Dialog>
  );
}
